module.exports = __webpack_public_path__ + "files/deepcath.bc07e9b8f075362191946c2a4b51d822.pdf";